import HomePage from './pages/home.vue';
import SalesPage from './pages/sales.vue';
import PaymentListPage from './pages/payment-list.vue';
import SettingsPage from './pages/settings.vue';
import NotFoundPage from './pages/not-found.vue';

import SideMenuPage from './pages/side-menu.vue';

export default [
  {
    path: '/',
    component: HomePage,
  },{
    path: '/menu/',
    component: SideMenuPage,
  },{
    path: '/sales/',
    component: SalesPage,
  },{
    path: '/payment-list/',
    component: PaymentListPage,
  },{
    path: '/settings/',
    component: SettingsPage,
  },{
    path: '(.*)',
    component: NotFoundPage,
  }
];



// WEBPACK FOOTER //
// ./src/routes.js